module.exports = __webpack_public_path__ + "static/media/project-04.8e3b0826.png";